<template>
    <tbody>
        <tr v-if="showGroupsRow(car.shipping_group_id)" class="shipping">
            <td colspan="37" style="background-color: white; font-size: medium">
                <p :class="{'fixed' : isNotMobile}">
                    <i class="fas fa-ship"></i>
                    #{{ car.shipping_group.id }}
                    <span @click="lockUnlockShippingGroup(null)" v-if="car.shipping_group.locked" class="icon has-text-danger">
                         <i class="fas fa-lock"></i>
                    </span>
                    <span @click="lockUnlockShippingGroup(1)" v-else class="icon has-text-success">
                        <i class="fas fa-lock-open"></i>
                    </span>
                    {{ car.shipping_group.name }}
                    ({{ getShippingGroupType(car.shipping_group.type) }})
                    ETD: <span class="has-text-primary">{{ car.estimated_departure }}</span>
                    ETA: <span class="has-text-primary">{{ car.estimated_arrival }}</span>
                    VESSEL: <span class="has-text-primary">{{ car.vessel }}</span>
                    B/l#: <a :href="'//' + car.shipping_line_url" target="_blank" class="has-text-primary">{{ car.bill_of_landing_number }}</a>
                </p>
            </td>
        </tr>
        <tr :class="isStriped">
            <td>
                <span>{{ car.user.name }}</span>
            </td>
            <td :class="{ 'gray': isStriped === 'gray', 'white': isStriped === 'white' }">
                <div class="level">
                    <figure class="image" style="float: left;">
                        <img :src="$appUrl+'/storage/photos/'+ car.id +'/2.jpg'" @error="imgUrlAlt($event, car.id, $appUrl)"/>
                    </figure>
                </div>
            </td>
            <td :class="{ 'gray': isStriped === 'gray', 'white': isStriped === 'white' }">
                <router-link :to="'/car/' + car.id" target="_blank">
                    {{ car.bid }}
                </router-link>
                <br>
                 {{ car.auction_name}}
            </td>
            <td>{{ car.model_type_en }}</td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.purchase_date) }">{{  formatDate(car.purchase_date) }}</button>
            </td>
            <td>
                <span v-if="car.shipping_group_id > 0">#{{ car.shipping_group.id }}</span>
                <span v-else>No group!</span>
            </td>
            <td>
                {{ car.company }}<br>
                {{ car.model_name_en }}
            </td>
            <td>
                {{ car.model_year_en }}<br>
                {{ car.mileage_num * 1000 | formatNumber}}
            </td>
            <td v-if="columnRemoved('result_price')">
                <strong v-if="!checkIfColumnIsHidden('result_price')">{{ car.price * 1000 | formatNumber }}</strong>
            </td>
            <td>
                <invoice-download-column :car="car"></invoice-download-column>
            </td>
            <td>
                <balance-column :car="car"></balance-column>
            </td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.yard_arrival_date) }">{{  formatDate(car.yard_arrival_date) }}</button>
            </td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.yard_pics) }">{{  formatDate(car.yard_pics)}}</button>
            </td>
            <td>
                <button class="button is-small tooltip" :class="{'bold': isFilled(car.port_of_loading) }" :data-tooltip="car.port_of_loading ? car.port_of_loading :'---'"><span class="text-eclipse">{{ car.port_of_loading ? car.port_of_loading :'---' }}</span></button>
            </td>
            <td>
                <button class="button is-small tooltip" :class="{'bold': isFilled(car.port_of_arrival) }" :data-tooltip="car.port_of_arrival ?  car.port_of_arrival : '---'"><span class="text-eclipse">{{ car.port_of_arrival ?  car.port_of_arrival : '---' }}</span></button>
            </td>
            <td>
                <button class="button is-small tooltip" :class="{'bold': isFilled(car.shipping_line) }" :data-tooltip="car.shipping_line ? car.shipping_line : '---'"><span class="text-eclipse">{{ car.shipping_line ? car.shipping_line : '---' }}</span></button>
            </td>
            <td>
                <button class="button is-small date-select tooltip" :class="{'bold': isFilled(car.vessel) }" :data-tooltip="car.vessel ? car.vessel : '---'"><span class="text-eclipse">{{ car.vessel ? car.vessel : '---' }}</span></button>
            </td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.export_certificate) }">{{  formatDate(car.export_certificate) }}</button>
            </td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.estimated_departure) }">{{  formatDate(car.estimated_departure) }}</button>
            </td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.estimated_arrival) }">{{  formatDate(car.estimated_arrival) }}</button>
            </td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.bill_of_landing) }">{{ formatDate(car.bill_of_landing) }}</button>
            </td>
            <td>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.docs_send) }">{{  formatDate(car.docs_send) }}</button>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import BalanceColumn from './Columns/BalanceColumn'
    import InvoiceDownloadColumn from './Columns/InvoiceDownloadColumn'
    import moment from 'moment'
    export default {
        props:['car', 'i'],
        components: {
            BalanceColumn,
            InvoiceDownloadColumn
        },
        data () {
            return {
                windowWidth: null,
                index: null,
                images: [],
                rowClass: '',
                carData: {
                    id: this.car.id,
                    query: {
                        shipping_group_id: this.car.shipping_group_id
                    }
                },
                statusLabels: [
                    {
                        tagClass: 'tag is-danger',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-link',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info',
                        label: 'Negotiations'
                    },
                ]
            }
        },
        methods: {
            checkIfColumnIsHidden(column) {
                let isHidden = false

                this.car.car_hidden_fields.map(object => {
                    if (object.name === column) {
                        isHidden = true
                    }
                })

                return isHidden
            },
            columnRemoved(column) {
                return this.$store.getters.checkIfCurrentUserCarColumnIsHidden(column)
            },
            daysPast(date, eta){

                const one_day = 1000 * 60 * 60 * 24;

                const date1 = new Date();
                const date2 = new Date(date);

                const date1_ms = date1.getTime();
                const date2_ms = date2.getTime();

                // Calculate the difference in milliseconds
                const difference_ms = date1_ms - date2_ms;

                // Convert back to days and return
                return Math.round(difference_ms / one_day);
            },
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            getShippingGroupType(type) {
                return type < 2 ? 'RoRo' : 'Container'
            },
            showGroupsRow(group){
                if (this.$store.getters.getCarsOrderColumn === 'shipping_group_id'){
                    if (group !== null) {
                        if (this.i === 0){
                            return true
                        }
                        return this.$store.getters.getCars[this.i - 1].shipping_group_id !== group
                    }
                }
            },
            isFilled(value) {
                if (value !== null){
                    return  true;
                }
            },
            imgUrlAlt(event, car_id, appurl){
                if(event.target.src.indexOf('1.jpg') > -1) {
                    event.target.src = '/static/images/hero-4.jpeg'
                }else{
                    event.target.src = appurl+'/storage/photos/'+ car_id +'/1.jpg';
                }
            }
        },
        computed: {
            isStriped() {
                if (this.i % 2 === 0) {
                    return 'white'
                } else {
                    return 'gray'
                }
            },
            isNotMobile() {
                return  this.windowWidth > 450;
            }
        },
        mounted() {
            for (let i = 1; i <= this.car.photos; i++) {
                this.images.push('https://unetworld.com/storage/photos/'+ this.car.id +'/'+ i +'.jpg')
            }
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.windowWidth = window.innerWidth
                });
            })
        }
    }
</script>

<style scoped>
    .white {
        background-color: white;
    }
    .gray {
        background-color: whitesmoke;
    }
    tbody{
        overflow-x: scroll;
        max-height: 500px;
    }
    td {
        font-size: 10px;
        font-weight: bold;
        /*background-color: whitesmoke;*/
    }
    .is-responsive-table td {
        font-size: 10px;
    }
    .image {
        /*max-height: 32px;
        height: 32px;*/
        padding-left: 2px;
        max-height: 100px;
        max-width: 100px;
    }
    .is-automatic {
        background-color: rgba(0, 255, 255, 0.25);
    }
    .is-real {
        background-color: rgba(255, 255, 0, 0.27);
    }
    .is-win {

    }
    .is-canceled {

    }
    .nowrap {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .is-responsive-table table {
        width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .shipping {
        width: 100%;
        height: 40px;
        border-style: solid;
        border-width: 1px;
        border-color: whitesmoke;
    }
    .text-eclipse {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .fixed {
        position: absolute;
    }

</style>



// WEBPACK FOOTER //
// src/components/Cars/CarUserTableRow.vue